export default {"src":"/_next/static/media/hiking.5d951edc.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};